export const definingPathForUser = (currentUser) => {
  switch (currentUser?.role) {
    case "author":
      return "/licensors";
    case "researcher":
      return "/researcher";
    case "admin":
      return "/admin";
    case "editor":
      return "/publishing";
    case "output editor":
      return "/publishing";
    case "gallery editor":
      return "/galleries";
    case "stringer":
      return "/stringer";
    case "company":
      return "/company";
    default:
  }
};

export const definingTextOfMenuItem = (currentUser) => {
  switch (currentUser?.role) {
    case "author":
      return "View sales dashboard";
    case "researcher":
      return "Team cabinet";
    case "admin":
      return "Admin panel";
    case "editor":
      return "Publishing";
    case "output editor":
      return "Publishing";
    case "gallery editor":
      return "Galleries";
    case "stringer":
      return "Personal area";
    case "company":
      return "Personal area";
    default:
  }
};
